import React, { Component } from 'react';
import { Form } from 'react-form';
import { Input, Select, PlayerSearch } from '../../Form';
import { required } from '../../../utils/validation';
import Popup from '../../Popup';
import { getPlayerName, getPlayerGradYearOptions, getClassYearOptions } from '../../../utils';
import { getRedshirtClassYearOptions, CLASS_YEAR_IDS } from '../../../utils/constants';
import styles from './addUpdatePlayerOnRosterPopUp.scss';

class AddUpdatePlayerOnRosterPopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: props.showAddPlayer ? 'add_player' : 'player_grad_year',
        };
    }

    // Helper: Get dropdown class year ID for display
    getDropdownClassYearId(currentClassYearId, currentRedshirt) {
        if (!currentClassYearId) {
            return null;
        }

        // If player is redshirted and is Graduate Student then show as Senior
        const isRedshirtedGraduateStudent = currentRedshirt && currentClassYearId === CLASS_YEAR_IDS.GRADUATE_STUDENT;
        return isRedshirtedGraduateStudent ? CLASS_YEAR_IDS.SENIOR : currentClassYearId;
    }

    // Helper: Get graduation year options based on context
    getGradYearOptions(isRostersRolloutEnabled, isCollege, showAddPlayer, currentRedshirt) {
        if (!isRostersRolloutEnabled) {
            return getPlayerGradYearOptions(true);
        }

        if (!isCollege) {
            return getClassYearOptions();
        }

        // For college rosters with redshirted players, show limited options
        const shouldShowAllOptions = showAddPlayer || !currentRedshirt;
        return shouldShowAllOptions ? getClassYearOptions() : getRedshirtClassYearOptions();
    }

    render() {
        const {
            onCloseClick,
            onCtaClick,
            playerId,
            playerName,
            showAddPlayer,
            clubSubTypeId,
            checkGate,
            featureGates,
            isCollege,
            currentClassYearId,
            currentRedshirt,
        } = this.props;

        const isRostersRolloutEnabled = checkGate && featureGates ? checkGate(featureGates.ROSTERS_ROLLOUT) : false;

        const dropdownClassYearId = this.getDropdownClassYearId(currentClassYearId, currentRedshirt);

        const defaultValues = {
            playerId,
            playerGradYear: null,
            classYearId: dropdownClassYearId,
        };

        const gradYearOptions = this.getGradYearOptions(isRostersRolloutEnabled, isCollege, showAddPlayer, currentRedshirt);
        const fieldName = isRostersRolloutEnabled ? 'classYearId' : 'playerGradYear';
        const yearLabel = isRostersRolloutEnabled ? 'Class Year' : 'Graduation Year';
        const yearText = isRostersRolloutEnabled ? 'class year' : 'graduation year';

        return (
            <Popup
                className={`popup-md`}
                popUpClassName={`${styles.addUpdatePlayerOnRosterPopUp}`}
                popUpContentWrapperClassName={`overflow-unset`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: false,
                    topGradient: false,
                    scrollable: false,
                }}
            >
                <div className={`${styles.section} pt0`}>
                    <h4>
                        {showAddPlayer ? 'Add Player to Roster' : `Change ${yearLabel} for ${playerName}`}
                    </h4>
                </div>
                <div className={`${styles.section} pt0 pb24`}>
                    <Form onSubmit={values => onCtaClick(values)} id="editGradYearForm" defaultValues={defaultValues}>
                        {({ submitForm, setValue }) => {
                            return (
                                <form onSubmit={submitForm} id="editGradYearForm">
                                    <Input id="playerId" field={'playerId'} value={`${playerId}`} type="hidden" />
                                    {showAddPlayer && this.state.step === 'add_player' && (
                                        <div className="row">
                                            <div className="col-12">
                                                <PlayerSearch
                                                    className="form-control"
                                                    placeholder="Add player to roster by name..."
                                                    showInvitePlayer={false}
                                                    data-testid="roster.player-search"
                                                    handlePlayerSelect={(player) => {
                                                        setValue('playerId', player.id);
                                                        this.setState({
                                                            playerName: getPlayerName(player.firstName, player.lastName),
                                                            step: 'player_grad_year',
                                                        });
                                                    }}
                                                    clearAfterSelect={true}
                                                    searchMembersOnly={false}
                                                    excludeProPlayers={true}
                                                    clubSubTypeId={clubSubTypeId}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {this.state.step === 'player_grad_year' && (
                                        <React.Fragment>
                                            {this.state.playerName && (
                                                <div className="row mt16">
                                                    <div className="col-12">
                                                        Please select a {yearText} for {this.state.playerName}
                                                    </div>
                                                </div>
                                            )}
                                            <div className="row mt16">
                                                <div className="col-12">
                                                    <Select
                                                        key={`player-grad-year`}
                                                        id={`player-grad-year`}
                                                        label={yearLabel}
                                                        field={fieldName}
                                                        emptyOption={`Please select a ${yearText}`}
                                                        options={gradYearOptions}
                                                        validate={required}
                                                        data-testid="roster-popup.class-year-select"
                                                    />
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    <hr />
                                    <div className="row">
                                        <div className="col-12 col-md-6 mb16">
                                            <button
                                                onClick={onCloseClick}
                                                type="button"
                                                className="btn btn-default btn-xl text-uppercase btn-block"
                                                data-testid="roster-popup.cancel-btn"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <button
                                                type="submit"
                                                className="btn btn-primary btn-xl text-uppercase btn-block"
                                                disabled={this.state.step === 'add_player'}
                                                data-testid="roster-popup.save-btn"
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            );
                        }}
                    </Form>
                </div>
            </Popup>
        );
    }
}

export default AddUpdatePlayerOnRosterPopUp;
